"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import Label from "@ingka/label";
import cx from "classnames";
const RadioButton = forwardRef(
  (props, publicRef) => {
    const {
      className,
      prefix = "",
      id,
      label,
      caption,
      name = "radioname",
      value,
      onChange,
      disabled = false,
      describedById,
      required,
      subtle = false,
      ...other
    } = props;
    const classes = cx(
      className,
      `${prefix}radio`,
      subtle && `${prefix}radio--subtle`
    );
    return /* @__PURE__ */ jsxs("span", { className: classes, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          type: "radio",
          value,
          name,
          id,
          ref: publicRef,
          disabled,
          onChange: disabled ? void 0 : onChange,
          "aria-describedby": describedById,
          required,
          ...other
        }
      ),
      /* @__PURE__ */ jsx("span", { className: `${prefix}radio__symbol` }),
      label && /* @__PURE__ */ jsxs("span", { className: `${prefix}radio__label`, children: [
        /* @__PURE__ */ jsx(Label, { prefix, htmlFor: id, label }),
        caption && /* @__PURE__ */ jsx("span", { className: `${prefix}radio__caption`, children: /* @__PURE__ */ jsx(Label, { prefix, htmlFor: id, label: caption }) })
      ] })
    ] });
  }
);
RadioButton.displayName = "RadioButton";
var RadioButton_default = RadioButton;
export {
  RadioButton_default as default
};
